import { setLoading, isLoading } from '../../principles/animations/loading';
import { formFieldValue } from '../../principles/selectors/formFieldValue';
import { emailExistsAsync } from '../../principles/form/accountApi';
import setHelpText from './setHelpText';
import texts from './texts';
import getActivePanel from '../../leadform/models/form/get_active_panel';

/**
 * Whether our email address is verified or not.
 */
let emailVerified = false;

/**
  * Intercept changes to email input and set email as unverified.
  */
document.addEventListener('change', (event) => {
  if(event.target.name === 'email_required') emailVerified = false;
});

/**
  * Handle navigation from account-email panel in order to interrupt it and
  * perform email address eligibility check.
  */
 export default function handleAccountEmailNavigation(event) {
  const { form } = event.detail;
  if(emailVerified) return;

  event.preventDefault(); // do not proceed immediately

  if(!isLoading(form)) {
    setLoading(form);

    const email = formFieldValue(form, 'email_required');
    emailExistsAsync(email)
      .then(handleEmailExists(form))
      .catch(catchEmailExistsError(form))
      .finally(stopLoading(form));
  }
}

/**
  * Builds a function that handles the output of emailExistsAsync,
  * adding or removing the help text about signing in, or clicking the button again
  * with the email being verified.
  */
 export const handleEmailExists = (form) => (exists) => {
  emailVerified = !exists;

  // If verified, click button again to proceed
  if(emailVerified) {
    setHelpText(form);
    setTimeout(() => {
      getActivePanel(form).querySelector('.edge-button--primary').click();
    }, 1);
  } else {
    setHelpText(form, texts.accountExists);
  }
};

export const catchEmailExistsError = (form) => (error) => {
  if(window.newrelic) window.newrelic.noticeError(error);
  console.error(error);
  setHelpText(form, texts.accountExists);
};

/**
  * Convenience thunk for promises to stop the loading animation.
  */
 const stopLoading = (form) => () => setLoading(form, false);
